import ErrorPageLayout from './ErrorPageLayout'

// eslint-disable-next-line import/no-unused-modules
export default ErrorPageLayout
